import { IHeroCustomizerSliderItem } from '../models/hero-customizer-slider-item';
import { IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models/product-with-attributes';
import { ProductAttributeKey } from '@gn-audio/core/common/enums';
import { Component, Input, Output } from 'angular-ts-decorators';
import { customPaging } from './utils/custom-paging';

import template from './hero-customizer-v3-image-gallery.component.html';

@Component({
  selector: 'heroCustomizerV3ImageGallery',
  template,
})
export class HeroCustomizerV3ImageGalleryComponent {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public items?: IHeroCustomizerSliderItem[];
  @Input() public group?: IProductWithAttributes;

  @Output() public onClose?: () => void;

  public customPaging(index: number): string {
    return customPaging(this.items, index, this.group.productName);
  }

  public get productRenderingUuid(): string {
    return this.group?.attributes?.find(
      (attribute) => attribute.key === ProductAttributeKey.Meta3dRenderingUuid
    )?.value;
  }
}
